module.exports = __webpack_public_path__ + "img/wallpaper-5.77298932.png";